import React from 'react'
import ReportStandardUserListMobileTab from './ReportStandardUserListMobileTab'
import { buildReportPosUserMobileCardSections } from './reportPosUserMobileCardModel'

export default function ReportPosMobileTab(props) {
  return (
    <ReportStandardUserListMobileTab {...props} buildCardSections={buildReportPosUserMobileCardSections} />
  )
}
